import ProductListII from './ProductListII';
import compose from 'recompose/compose';
import when from 'recompose/branch';
import formatPrismicData from '../../hocs/formatPrismicData';
import { withFiltering } from '../ProductList/helpers';

const enhance = compose(
  formatPrismicData,
  when(props => props.addFiltering, withFiltering)
);

export default enhance(ProductListII);



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductListII/index.js